import { api } from '@/plugins'

export function logClientError(page, errorCode, context = {}) {
  api.post('/client_logs', { page, error_code: errorCode, context }, { _noToast: true }).catch((e) => {
    console.error(e)
  })
}
